import type { JSX } from "solid-js";

type Props = {
	isActivePortrait: () => boolean;
	children: JSX.Element;
};

/**
 * Viewport for the video panel carousel.
 */
export const VideoPanelCarouselViewport = (props: Props) => {
	return (
		<div
			class="video-panel-carousel__viewport"
			classList={{
				"video-panel-carousel__viewport--portrait": props.isActivePortrait(),
			}}
		>
			{props.children}
		</div>
	);
};
